import 'slick-carousel/slick/slick';

const breakpoints = {
    xlg: 1455,
    lg: 1200,
    md: 992,
    sm: 768,
    xs: 576
};

function cookies() {
    var cookieInfo = $('#cookies-info'),
        cookieClose = $('#cookies-info').find('.cookies-info__accept');
    checkCookie();

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + expires + "; path=/";

    };

    function getCookie(cname) {

        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return '';
    };

    function checkCookie() {
        var isExist = getCookie(document.domain + '-cookies-info');
        if (isExist != '') {
            cookieInfo.hide();
        } else {
            cookieInfo.show();
            cookieClose.on('click', function (e) {
                e.preventDefault();
                cookieInfo.hide();
                isExist = true;
                if (isExist != "" && isExist != null) {
                    setCookie(document.domain + '-cookies-info', isExist, 365);
                }
            });
        }
    };

};

function checkPage(pageClass) {
    return document.querySelector('.' + pageClass) ? true : false;
};

function windowScroll(targetID) {
    const body = document.body,
        bodyRect = body.getBoundingClientRect().top,
        elementRect = body.querySelector(targetID).getBoundingClientRect().top;
    let elementPosition = elementRect - bodyRect;

    if (window.innerWidth < breakpoints.sm) {
        elementPosition = elementPosition - 20;
    }

    let timer = 0;

    timer = setTimeout(() => {
        window.scrollTo({top: elementPosition, behavior: 'smooth'});
    }, 100);

    return body.querySelector(targetID);
}

export default {cookies, checkPage, windowScroll, breakpoints};
